export interface HighlightSegment {
    text: string;
    matched: boolean;
}

/** Splits text into alternating matched and unmatched runs for a search term.
 *
 * Returns segments rather than markup so the caller renders them as elements: the text is
 * entity-provided, and building an HTML string here would put it one `v-html` away from being
 * executed. Matching is done by scanning lowercased copies rather than with a regular expression,
 * so a term containing regex metacharacters is compared literally with nothing to escape.
 */
export function highlightSegments(text: string, term: string): HighlightSegment[] {
    const needle = term.trim().toLowerCase();
    if (!needle || !text) {
        return [ { text, matched: false } ];
    }

    const haystack = text.toLowerCase();
    const segments: HighlightSegment[] = [];
    let cursor = 0;

    for (let at = haystack.indexOf(needle, cursor); at >= 0; at = haystack.indexOf(needle, cursor)) {
        if (at > cursor) {
            segments.push({ text: text.slice(cursor, at), matched: false });
        }
        segments.push({ text: text.slice(at, at + needle.length), matched: true });
        cursor = at + needle.length;
    }

    if (cursor < text.length) {
        segments.push({ text: text.slice(cursor), matched: false });
    }
    return segments.length > 0 ? segments : [ { text, matched: false } ];
}
